import api from './api';
import type { PeRegister as _PeRegister } from '../components/proAcademy/proAcademyFilters';
import type { ProHoofdmap, ProHoofdmapInfo, ProTraining } from './professionalAcademyApi';

/**
 * Professional Academy — filter-, sorteer- & zoekengine (/api/pro-academy).
 * De reistijd-filter (postcode) blijft in de browser; zie utils/pc4Afstand.ts.
 */

export type PeRegister = _PeRegister;
export type ProLeervormFilter = 'e_learning' | 'klassikaal';
export type ProSortering = 'relevantie' | 'start' | 'prijs' | 'pe';

export interface Vakgebied {
  professional_type: string;
  label: string;
  hoofdmap: ProHoofdmap;
  rij: number;
  hoofdmap_label: string;
  score: number;
}

/** Tegel van het expertportaal + de velden die de zoekengine extra levert. */
export type ProZoekTraining = ProTraining & {
  locatie_postcode: string | null;
  lesdagen: number[];
  registers: PeRegister[];
};

export interface ProZoekResultaat {
  filters: Record<string, unknown> & { hoofdmap_effectief: ProHoofdmap | null };
  vakgebied: Omit<Vakgebied, 'score'> | null;
  totaal: number;
  afgekapt: boolean;
  trainingen: ProZoekTraining[];
  hoofdmappen: Array<ProHoofdmapInfo & { aantal: number }>;
}

export interface ProZoekMeta {
  registers: Array<{ key: PeRegister; label: string; doelgroep: string }>;
  hoofdmappen: ProHoofdmapInfo[];
  pe_max: number;
}

export interface ProZoekParams {
  vak?: string;
  map?: ProHoofdmap;
  q?: string;
  reg?: PeRegister[];
  pe?: number;
  vorm?: ProLeervormFilter;
  examen?: boolean;
  dag?: number[];
  hobby?: boolean;
  alles?: boolean;
  sort?: ProSortering;
}

export const zoekVakgebieden = async (q: string): Promise<Vakgebied[]> => {
  const response = await api.get(`/pro-academy/vakgebieden?q=${encodeURIComponent(q)}`);
  return response.data.data;
};

export const zoekProAcademy = async (p: ProZoekParams): Promise<{ data: ProZoekResultaat; meta: ProZoekMeta }> => {
  const params = new URLSearchParams();
  if (p.vak) params.set('vak', p.vak);
  if (p.map) params.set('map', p.map);
  if (p.q) params.set('q', p.q);
  if (p.reg?.length) params.set('reg', p.reg.join(','));
  if (p.pe) params.set('pe', String(p.pe));
  if (p.vorm) params.set('vorm', p.vorm);
  if (p.examen) params.set('examen', '1');
  if (p.dag?.length) params.set('dag', p.dag.join(','));
  if (p.hobby) params.set('hobby', '1');
  if (p.alles) params.set('alles', '1');
  if (p.sort) params.set('sort', p.sort);
  const response = await api.get(`/pro-academy/zoek?${params}`);
  return { data: response.data.data, meta: response.data.meta };
};
